import { render, staticRenderFns } from "./MfaView.vue?vue&type=template&id=3ef019f8&"
import script from "./MfaView.vue?vue&type=script&lang=ts&"
export * from "./MfaView.vue?vue&type=script&lang=ts&"
import style0 from "./MfaView.vue?vue&type=style&index=0&id=3ef019f8&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports